import PNAndTF from './pn-and-tf.vue';
import PNOnly from './pn-only.vue';
import { additionalConfigType, AdditionalConfigTypeEnums } from '../helper';

const configMap = {
  [AdditionalConfigTypeEnums.PN_AND_TF]: PNAndTF,
  [AdditionalConfigTypeEnums.PN_ONLY]: PNOnly,
  [AdditionalConfigTypeEnums.NONE]: null
};

export default configMap[additionalConfigType.configType];
